// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCardSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { CoordinationCardRelevance, CoordinationCardRelevanceData, CoordinationCardRelevanceOptions } from 'data/models/CoordinationCardRelevance';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { Event, EventData, EventOptions } from 'data/models/Event';

// CoordinationCardSelfData is the class that CoordinationCardSelf serializes to/from
export interface CoordinationCardSelfData {
    Id : number;
	
    Comments : CommentData[] | null;
    CommentsUrl : string;
    Events : EventData[] | null;
    Live : CoordinationCardData | null;
    Log : CoordinationCardRelevanceData[] | null;
    Versions : CoordinationCardVersionData[] | null;
	
}

// CoordinationCardSelfOptions is the class which may be passed to the CoordinationCardSelf constructor to define optional initial data values
export interface CoordinationCardSelfOptions {
    Id : number;
	
    Comments? : CommentOptions[] | null;
    CommentsUrl? : string;
    Events? : EventOptions[] | null;
    Live? : CoordinationCardOptions | null;
    Log? : CoordinationCardRelevanceOptions[] | null;
    Versions? : CoordinationCardVersionOptions[] | null;
	
}

export class CoordinationCardSelf {
    public Id : DataSignal<number>;
	
    public Comments : SDataArray<Comment>;
    public CommentsUrl : DataSignal<string>;
    public Events : SDataArray<Event>;
    public Live : DataSignal<CoordinationCard | null>;
    public Log : SDataArray<CoordinationCardRelevance>;
    public Versions : SDataArray<CoordinationCardVersion>;
	

    constructor();
    constructor(data : CoordinationCardSelfOptions);
    constructor(data: CoordinationCardSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Comments = SArray<Comment>([]);
        this.CommentsUrl = jsonableObservable(S.value<string>(data && data.CommentsUrl !== undefined ? data.CommentsUrl : ''));
        this.Events = SArray<Event>([]);
        this.Live = S.value<CoordinationCard | null>(null);
        this.Log = SArray<CoordinationCardRelevance>([]);
        this.Versions = SArray<CoordinationCardVersion>([]);
	    
    }

    static key(obj : CoordinationCardSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : CoordinationCardSelfOptions) {
        return obj.Id;
    }

    static update(obj : CoordinationCardSelf, data : CoordinationCardSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CommentsUrl !== undefined) obj.CommentsUrl(data.CommentsUrl);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardSelf.ts